var render = function render(){var _vm=this,_c=_vm._self._c;return (!!_vm.atopicDermatitisQuestion)?_c('keep-alive',[_c(_vm.atopicDermatitisQuestion,_vm._b({tag:"component",attrs:{"disabled":_vm.disabled},model:{value:(_vm.modelValue),callback:function ($$v) {_vm.modelValue=$$v},expression:"modelValue"}},'component',_vm.questionData,false))],1):_c('div')
}
var staticRenderFns = []

export { render, staticRenderFns }